// extracted by mini-css-extract-plugin
export default {"body":"UnderConstruction_body__CBgii","container":"UnderConstruction_container__JY6bk","title":"UnderConstruction_title__PP+aa","text":"UnderConstruction_text__x1JVq"};